export function isNotObject(value: string | boolean | number | object): boolean {
  return !(Object.prototype.toString.call(value) === '[object Object]')
}

export function isObjectT<T>(value: string | boolean | number | object | T): boolean {
  return Object.prototype.toString.call(value) === '[object Object]'
}
